import { Theme, themeToTokensObject } from '@fluentui/react-components';
import { corptaxDefaultLightTheme } from './corptaxLightTheme';

const customPalette = {
    darkThemeNeutral10: '#222222',
    darkThemeNeutral20: '#2F3030',
    darkThemeNeutral40: '#484B4C',
};

export const corptaxCustomLightTheme: Theme & {
    colorDarkThemeRest: string;
    colorDarkThemeHovered: string;
    colorDarkThemePressed: string;
    colorDarkThemeSelected: string;
} = {
    ...corptaxDefaultLightTheme,
    colorDarkThemeRest: customPalette.darkThemeNeutral20,
    colorDarkThemeHovered: customPalette.darkThemeNeutral40,
    colorDarkThemePressed: customPalette.darkThemeNeutral10,
    colorDarkThemeSelected: customPalette.darkThemeNeutral40,
};

export const corptaxThemeTokens = themeToTokensObject(corptaxCustomLightTheme);
